module.exports = __webpack_public_path__ + "assets/img/wdc.8004f4b5.png";